// extracted by mini-css-extract-plugin
module.exports = {"modal_title":"styles_modal_title__1NvG2","modal_desc":"styles_modal_desc__2gJ1I","button__disagree":"styles_button__disagree__2PtvW","button__agree":"styles_button__agree__1yQqL"};